// Translations for the Login page (runs before authentication).
const loginDict = [
  { en: "TAREWU Management System", sw: "Mfumo wa Usimamizi wa TAREWU" },
  { en: "Invalid email or password", sw: "Barua pepe au nenosiri si sahihi" },
  { en: "Email", sw: "Barua pepe" },
  { en: "Enter your email", sw: "Weka barua pepe yako" },
  { en: "Password", sw: "Nenosiri" },
  { en: "Enter your password", sw: "Weka nenosiri lako" },
  { en: "Signing in...", sw: "Inaingia..." },
  { en: "Sign In", sw: "Ingia" },
  { en: "Demo Credentials:", sw: "Taarifa za Kuingia za Majaribio:" },
  { en: "Forgot password?", sw: "Umesahau nenosiri?" },
  { en: "Forgot password", sw: "Umesahau nenosiri" },
  { en: "Back to sign in", sw: "Rudi kuingia" },
  { en: "Enter the email you sign in with, or your registered phone number. We will send you a link to set a new password.", sw: "Weka barua pepe unayotumia kuingia, au namba ya simu uliyosajili. Tutakutumia kiungo cha kuweka nenosiri jipya." },
  { en: "Email or phone number", sw: "Barua pepe au namba ya simu" },
  { en: "Send reset link", sw: "Tuma kiungo" },
  { en: "If an account matches, a password reset link has been sent by SMS and email. It is valid for 60 minutes.", sw: "Kama akaunti ipo, kiungo cha kubadilisha nenosiri kimetumwa kwa SMS na barua pepe. Kinadumu dakika 60." },
  { en: "Did not receive it? Check that you used the email or phone number registered with TAREWU, wait two minutes and try again, or contact the TAREWU office.", sw: "Hujapokea? Hakikisha umetumia barua pepe au namba ya simu iliyosajiliwa TAREWU, subiri dakika mbili ujaribu tena, au wasiliana na ofisi ya TAREWU." },
  { en: "Set a new password", sw: "Weka nenosiri jipya" },
  { en: "New password", sw: "Nenosiri jipya" },
  { en: "Confirm new password", sw: "Thibitisha nenosiri jipya" },
  { en: "Save new password", sw: "Hifadhi nenosiri jipya" },
  { en: "Use a password with at least 8 characters.", sw: "Tumia nenosiri lenye herufi 8 au zaidi." },
  { en: "The two passwords do not match.", sw: "Manenosiri mawili hayalingani." },
  { en: "This reset link is invalid or has expired. Ask for a new one.", sw: "Kiungo hiki si sahihi au muda wake umekwisha. Omba kingine." },
  { en: "Ask for a new link", sw: "Omba kiungo kipya" },
  { en: "Your password has been changed. Sign in with the new password.", sw: "Nenosiri lako limebadilishwa. Ingia kwa nenosiri jipya." },
  { en: "Something went wrong. Try again.", sw: "Hitilafu imetokea. Jaribu tena." },
  { en: "Show", sw: "Onyesha" },
  { en: "Hide", sw: "Ficha" },
];

export default loginDict;
